export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_sv.e5747a02932a925b.json"